export const removeLangFromUrl = (url: string) => {
  if (!url.startsWith("/en/")) {
    return url;
  }

  return `/${url.substr(4)}`;
};
